/* @ngInject */
export default function CopyReportLinkModalController($uibModalInstance, text) {
  const vm = this;
  vm.text = text;

  vm.close = () => {
    $uibModalInstance.dismiss('close');
  };
}
